var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: {
              "aria-hidden": "true",
              "tooltip-placement": "right",
              "uib-tooltip": "Cancel"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              href: _vm.href,
              disabled: _vm.currentNumberPool.isSelf,
              "data-testid": "pool-edit-btn"
            },
            on: { click: _vm.showForm }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("NUMBER_POOLS_ACTIONS_EDIT"),
                  expression: "$t('NUMBER_POOLS_ACTIONS_EDIT')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-edit",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "NUMBER_POOLS_ACTIONS_EDIT",
                  expression: "'NUMBER_POOLS_ACTIONS_EDIT'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              disabled: _vm.disabled || _vm.currentNumberPool.isSelf,
              "data-testid": "pool-delete-btn"
            },
            on: { click: _vm.confirmDelete }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("NUMBER_POOLS_ACTIONS_DELETE"),
                  expression: "$t('NUMBER_POOLS_ACTIONS_DELETE')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-trash",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "NUMBER_POOLS_ACTIONS_DELETE",
                  expression: "'NUMBER_POOLS_ACTIONS_DELETE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          "is-disabled": _vm.disabled,
          "object-id": _vm.currentNumberPool.id,
          "object-name": _vm.currentNumberPool.name,
          "object-type": "NumberPool"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }